import { render } from "./top-traders.vue?vue&type=template&id=96234c18"
import script from "./top-traders.vue?vue&type=script&lang=js"
export * from "./top-traders.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__